"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SactionView = exports.SactionSortOrder = exports.SactionSortField = void 0;
var SactionSortField;
(function (SactionSortField) {
    SactionSortField["PRICE"] = "price";
    SactionSortField["NET_SIZE"] = "netsize";
    SactionSortField["GROSS_SIZE"] = "grosssize";
    SactionSortField["DISTRICT"] = "district";
    SactionSortField["BUILDING"] = "name";
    SactionSortField["UDPATE"] = "updateddate";
    SactionSortField["QUALITY"] = "qualityscore";
    SactionSortField["PRICEPERSQFT"] = "pricepersqft";
})(SactionSortField = exports.SactionSortField || (exports.SactionSortField = {}));
var SactionSortOrder;
(function (SactionSortOrder) {
    SactionSortOrder["ASC"] = "asc";
    SactionSortOrder["DESC"] = "desc";
})(SactionSortOrder = exports.SactionSortOrder || (exports.SactionSortOrder = {}));
var SactionView;
(function (SactionView) {
    SactionView[SactionView["GRID"] = 0] = "GRID";
    SactionView[SactionView["LIST"] = 1] = "LIST";
    SactionView[SactionView["MAP"] = 2] = "MAP";
})(SactionView = exports.SactionView || (exports.SactionView = {}));
